<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>credit_card</md-icon>
        </div>
        <h4 class="title">Balance Log</h4>
      </md-card-header>
      <md-card-content>
        <md-table id="logsTable" :value="logs" class="paginated-table table-striped table-hover">
          <md-table-toolbar>
            <md-field>
              <label>Per page</label>
              <md-select v-model="handleProps.perPage">
                <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Date">{{ item.created_at | moment }}</md-table-cell>
            <md-table-cell md-label="Order ID">{{ item.order_id || "" }}</md-table-cell>
            <md-table-cell md-label="Type">{{ item.type }}</md-table-cell>
            <md-table-cell md-label="Amount">{{ formatBalance(item.amount) }}</md-table-cell>
            <md-table-cell md-label="Balance">{{ formatBalance(item.ending_balance) }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <div>
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} logs
          </p>
        </div>
        <pagination class="pagination-no-border pagination-success" v-model="handleProps.currentPage" :per-page="handleProps.perPage" :total="total">
        </pagination>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import IntToMoneyFormatter from "@/mixins/money-formatter-mixin.js"
import { Pagination } from "@/components";
import moment from "moment"

export default {
  name: "balance-logs-table",
  mixins: [ IntToMoneyFormatter ],
  components: { Pagination },
  created() {
    this.getLogs()
  },
  props: {
    walletID: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      pagination: {
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      logs: [],
      handleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 25
      }
    }
  },
  computed: {
    to() {
      let highBound = this.from + this.handleProps.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.handleProps.perPage * (this.handleProps.currentPage - 1)
    },
    total() {
      return this.pagination.total
    }
  },
  methods: {
    getLogs() {
      this.$http.secured.post(`/v1/balance-logs/user?page=${this.handleProps.currentPage}&page_count=${this.handleProps.perPage}`,
       { wallet_id: this.walletID })
        .then(response => {
          this.logs = response.data.logs
          this.pagination.total = response.data.meta.total
        }) 
        .catch(error => alert(error))
    }
  },
  watch: {
    handleProps: {
      handler() {
        this.getLogs()
      },
      deep: true
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format('MM/DD/YY hh:mm A');
    }
  },
}
</script>

<style lang=scss>
#logsTable.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
  text-align: unset !important;
  justify-content: left !important;
}
</style>